<section aria-label="Teams" class="team-list">
  <div *ngIf="teams.length === 0" class="list-state">No named teams found.</div>
  <div *ngIf="teams.length > 0" class="team-legend">
    <strong
      >Collectors free for each full {{ bucketMinutes }}-minute slot</strong
    >
    <span aria-hidden="true" class="legend-gradient"></span>
    <span>Fewer</span>
    <span>More</span>
  </div>
  <article *ngFor="let team of teams; trackBy: trackByTeam" class="team-card">
    <button (click)="selectTeam(team.team)" class="team-heading" type="button">
      <strong>{{ team.team }}</strong>
      <span>{{ team.total }} collectors</span>
    </button>
    <div class="team-summary">
      <span *ngIf="team.availableAtLeastOnceInSelectedRange !== null">
        <strong>{{ team.availableAtLeastOnceInSelectedRange }}</strong> free at
        least once in period
      </span>
      <span
        ><strong>{{ peakFree(team) }}</strong> peak free for a full
        {{ bucketMinutes }}-minute slot in period</span
      >
      <span
        ><strong>{{ team.freeForEntireSelectedRange }}</strong> free for the
        entire period</span
      >
    </div>
    <div [attr.aria-label]="team.team + ' team timeline'" class="team-timeline">
      <button
        (blur)="hideSegment(team.team)"
        (focus)="showSegment(team.team, segment)"
        (mouseenter)="showSegment(team.team, segment)"
        (mouseleave)="hideSegment(team.team)"
        *ngFor="let segment of team.timeline; trackBy: trackBySegment"
        [attr.aria-label]="segmentTitle(segment)"
        [attr.title]="segmentTitle(segment)"
        [style.left.%]="minuteToPercentage(segment.fromMinute)"
        [style.opacity]="segmentOpacity(segment.freeRatio)"
        [style.width.%]="
          minuteToPercentage(segment.toMinute) -
          minuteToPercentage(segment.fromMinute)
        "
        class="team-segment"
        type="button"
      ></button>
      <span
        [style.width.%]="minuteToPercentage(selectedFromMinute)"
        aria-hidden="true"
        class="range-mask range-before"
      ></span>
      <span
        [style.left.%]="minuteToPercentage(selectedFromMinute)"
        [style.width.%]="
          minuteToPercentage(selectedToMinute) -
          minuteToPercentage(selectedFromMinute)
        "
        aria-hidden="true"
        class="selected-range"
      ></span>
      <span
        [style.left.%]="minuteToPercentage(selectedToMinute)"
        aria-hidden="true"
        class="range-mask range-after"
      ></span>
    </div>
    <div aria-hidden="true" class="team-hours">
      <span>00:00</span><span>06:00</span><span>12:00</span><span>18:00</span
      ><span>24:00</span></div
    >
    <div aria-live="polite" class="segment-details">
      <ng-container
        *ngIf="currentSegment(team.team) as segment; else segmentHint"
      >
        {{ segmentTitle(segment) }}
      </ng-container>
      <ng-template #segmentHint
        >Hover or focus the timeline for exact counts.</ng-template
      >
    </div>
  </article>
</section>
